import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Comments from '../../../components/comments';
import DocumentService from '../../../services/document.service';

const DocumentPreview = ({
  t,
  errors,
  images,
  isImage,
  commented,
  currentPage,
  onErrorImage,
  downloadLink,
  activeDocument,
  showComments,
  sliderSettings,
  backgroundColor,
}) => (
  <div className="boxs dpreviewscrollto">
    {errors ?
      <div className="nopreview boxs chosefl chosefl1">
        <h2 className="fontmulisemi">{t('No preview available')}</h2>
        <div className="nopre_img boxs">
          <img src="/img/nopreview.svg" alt="nopreview" />
        </div>
        <h2 className="fontmulisemi font2">
          <a href={downloadLink}>
            {t('You can download the file')}
          </a>
        </h2>
      </div> :

      <div className="docpreview boxs chosefl chosefl2">
        <div className="arrowtop">
          { !isImage && activeDocument.count_pages ?
            <p><span>&nbsp;{currentPage + 1}&nbsp;</span>/<span>&nbsp;{activeDocument.count_pages}&nbsp;</span></p>
            : ''
          }
          <div className="download">
            <ul>
              <li className="actiondiv">
                <a
                  href={downloadLink}
                  className="actionlink"
                >{t('Download')}
                  <i
                    className="fa fa-caret-down car-l"
                    aria-hidden="true"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
        {!isImage ? <Slider {...sliderSettings}>
          {Object.keys(images).map(i => (
            <div className="docfile boxs" key={i}>
              <img src={images[i]} alt="docfile" onError={onErrorImage} />
            </div>
            ))}
        </Slider> :
        <div className="docfile boxs">
          <img src={images[0]} alt="docfile" onError={onErrorImage} className="docfile-img" />
        </div>
        }
      </div>
    }
    {showComments && commented && <Comments
      model_id={activeDocument.id}
      commented={commented}
      model_name={DocumentService.modelName}
      backgroundColor={backgroundColor}
    />}
  </div>

);

DocumentPreview.propTypes = {
  errors: PropTypes.bool,
  images: PropTypes.object,
  t: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  activeDocument: PropTypes.object,
  commented: PropTypes.bool.isRequired,
  onErrorImage: PropTypes.func.isRequired,
  sliderSettings: PropTypes.object.isRequired,
  backgroundColor: PropTypes.string.isRequired,
};

export default DocumentPreview;



// WEBPACK FOOTER //
// ./src/components/modules/documentPreview/DocumentPreview.jsx